export default "__VITE_ASSET__CDeFbjCQ__"